import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})

export class AvisosPrivacidadService {

  API_URI = environment.API_URL;
  constructor(private http: HttpClient) { }

  getAvisosPrivacidad() { 
    // console.log(this.http);
    return this.http.get(`${this.API_URI}/avisos-privacidad`);
     
  }

}
